import React from 'react'
import { AutoTrader } from '@zuto/icons'
import { VehicleDetailsDataObject } from '../../services/vehicle-service'
import VehicleInfo from './VehicleInfo'
import { Box, Grid } from '@mui/material'
import Image from 'next/image'

export type BaseAtLandingPageV6StyledProps = {
  $atLandingPageV6?: boolean;
  $vehicleImg?: boolean;
}

interface SimpleVehicleCardProps {
  vehicle: VehicleDetailsDataObject;
  vehicleImg?: string;
}

const SimpleVehicleCard = ({
  vehicle,
  vehicleImg
}: SimpleVehicleCardProps): JSX.Element => {
  // const hasVehicleImage = (imageLoaded && vehicleImg : false)
  const vehicleSourceResized = vehicleImg
    ? vehicleImg.replace('/w300/', '/w480h360/')
    : ''


  const renderImage = () => {
    return (
      <Box
      sx={{
        width: 123,
        height: 123,
        borderRadius: '12px',
        overflow: 'hidden',
        position: 'relative'
      }}
      >
      <Image
        src={vehicleSourceResized}
        alt={`${vehicle.make} ${vehicle.model}`}
        layout='fill'
        objectFit='cover'
        data-testid="vehicle-small-image"
        id="tag_main-vehicle-small-image"
      />
    </Box>
    )
  }

  const renderAutoTraderLogo = () => (
    <AutoTrader
      data-testid='autotrader-logo'
      viewBox='0 0 151 32'
    />
  )

  return (
    <Grid container>
      <Box mr={7} mt={6} alignItems='center' justifyContent='center' flexDirection='column' display='flex' >
      {vehicleImg ? renderImage(): renderAutoTraderLogo()}
      </Box>
      <Box mt={6}>
        {vehicleImg && <Box mb={2}>{renderAutoTraderLogo()}</Box>}
        <VehicleInfo vehicle={vehicle as VehicleDetailsDataObject} />
      </Box>
    </Grid>
  )
}

export default SimpleVehicleCard
